export const listConversations = async () => {
  const response = await fetch("https://api.pwyll.io/conversations", {
    method: "GET",
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};
